<app-breadcrumb [title]="title" [breadcrumbs]="breadcrumbs"></app-breadcrumb>
<app-tangy-forms-player [skipSaving]="true" #formPlayer></app-tangy-forms-player>